import React from "react";
import {withNamespaces} from "react-i18next";
import {Link, useLocation} from "react-router-dom";

import {
    landingNavigation,
} from "../../../config/landing-navigation.config";
import {
    getLandingSectionHref,
} from "../../../presentation/public-site/route-policy";
import {
    useCookieConsent,
} from "../../cookie-consent/provider";

export function SiteFooterContent({t}) {
    const location = useLocation();
    const {openSettings} = useCookieConsent();

    return (
        <footer className="footer footer--site">
            <div className="container public-site-shell">
                <div className="site-footer">
                    <div className="site-footer__columns">
                        <div className="site-footer__column">
                            <strong>
                                {t(
                                    "main.landing.footer.platformTitle"
                                )}
                            </strong>

                            <nav
                                aria-label={t(
                                    "main.landing.footer.navigationAriaLabel"
                                )}
                            >
                                {landingNavigation.map((item) => (
                                    <a
                                        href={getLandingSectionHref(
                                            location.pathname,
                                            item.id
                                        )}
                                        key={item.id}
                                    >
                                        {t(item.labelKey)}
                                    </a>
                                ))}
                            </nav>
                        </div>

                        <div className="site-footer__column">
                            <strong>
                                {t(
                                    "main.landing.footer.companyTitle"
                                )}
                            </strong>

                            <nav
                                aria-label={t(
                                    "main.landing.footer.companyNavigationAriaLabel"
                                )}
                            >
                                <Link to="/contacts">
                                    {t(
                                        "main.landing.footer.companyLinks.contacts"
                                    )}
                                </Link>

                                <a
                                    href="/documents/company/Описание функциональных характеристик ПО.pdf"
                                    download
                                >
                                    {t(
                                        "main.landing.footer.companyLinks.functionality"
                                    )}
                                </a>

                                <a
                                    href="/documents/company/Описание жизненного цикла ПО.pdf"
                                    download
                                >
                                    {t(
                                        "main.landing.footer.companyLinks.lifecycle"
                                    )}
                                </a>
                            </nav>
                        </div>

                        <div className="site-footer__column">
                            <strong>
                                {t(
                                    "main.footer.documents.title"
                                )}
                            </strong>

                            <nav
                                aria-label={t(
                                    "main.landing.footer.legalNavigationAriaLabel"
                                )}
                            >
                                <Link to="/privacy-page?tab=agreement">
                                    {t(
                                        "main.footer.documents.list.doc3"
                                    )}
                                </Link>

                                <Link to="/privacy-page?tab=terms">
                                    {t(
                                        "main.footer.documents.list.doc4"
                                    )}
                                </Link>

                                <Link to="/privacy-page?tab=offer">
                                    {t(
                                        "main.footer.documents.list.doc5"
                                    )}
                                </Link>

                                <button
                                    type="button"
                                    onClick={openSettings}
                                >
                                    {t(
                                        "cookieConsent.actions.openSettings"
                                    )}
                                </button>
                            </nav>
                        </div>

                        <div className="site-footer__column">
                            <strong>
                                {t(
                                    "main.landing.footer.supportTitle"
                                )}
                            </strong>

                            <div className="site-footer__contacts">
                                <a href="tel:88002227079">
                                    8 (800) 222-70-79
                                </a>

                                <a href="mailto:support@svetofore.ru">
                                    support@svetofore.ru
                                </a>
                            </div>

                            <div className="site-footer__social">
                                <a
                                    href="https://max.ru/id2462225394_biz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={t(
                                        "main.landing.footer.social.max"
                                    )}
                                >
                                    <img
                                        src="/img/max.png"
                                        alt=""
                                    />
                                </a>

                                <a
                                    href="https://dzen.ru/svetoforelogistic"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={t(
                                        "main.landing.footer.social.dzen"
                                    )}
                                >
                                    <img
                                        src="/img/zen.svg"
                                        alt=""
                                    />
                                </a>

                                <a
                                    href="https://vk.ru/svetofor_log"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={t(
                                        "main.landing.footer.social.vk"
                                    )}
                                >
                                    <img
                                        src="/img/vk.svg"
                                        alt=""
                                    />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="site-footer__services">
                        <a
                            className="site-footer__service"
                            href="https://play.google.com/store/apps/details?id=com.uvezem&hl=ru&gl=US"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="site-footer__service-icon">
                                <img src="/img/app.svg" alt=""/>
                            </span>

                            <span>
                                <small>
                                    {t(
                                        "main.landing.footer.services.mobileLabel"
                                    )}
                                </small>

                                <strong>
                                    {t("main.footer.app")}
                                </strong>
                            </span>
                        </a>

                        <a
                            className="site-footer__service"
                            href="https://max.ru/id2462225394_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="site-footer__service-icon">
                                <img src="/img/max.png" alt=""/>
                            </span>

                            <span>
                                <small>
                                    {t(
                                        "main.landing.footer.services.maxLabel"
                                    )}
                                </small>

                                <strong>
                                    {t("main.footer.bot")}
                                </strong>
                            </span>
                        </a>

                        <div className="site-footer__service">
                            <span className="site-footer__service-icon">
                                <img src="/img/app2.svg" alt=""/>
                            </span>

                            <span>
                                <small>
                                    {t(
                                        "main.landing.footer.services.telegramLabel"
                                    )}
                                </small>

                                <strong>
                                    {t("main.footer.botTg")}
                                </strong>
                            </span>
                        </div>
                    </div>

                    <div className="site-footer__bottom">
                        <span>
                            {t("main.footer.copyright")}
                        </span>

                        <span>
                            {t(
                                "main.landing.footer.trialNote"
                            )}
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default withNamespaces("translation")(
    SiteFooterContent
);
